'use strict';
import customModal from '../../modal';
import util from '../../util';
import qs from 'qs';
import _ from 'lodash-es';
import currentLayout from '../../detect-layout';
import zoom from '../../pinch-zoom';
import dragscroll from '../../dragscroll';
import imagesLoaded from 'imagesloaded';
import video from '../../video';

const SessionAttributes = window.SessionAttributes;
let videoplayer = null;

var checkLayout = currentLayout.init(),
	isTouchDevice = ('ontouchstart' in document.documentElement);

if(isTouchDevice) {	
	if (localStorage.getItem("pinchImageSessionCount") === null && localStorage.getItem("pageSessionID") === null) {
		localStorage.setItem('pinchImageSessionCount', 0);
		localStorage.setItem('pageSessionID', SessionAttributes.SESSION_ID);
	}
	
	if( localStorage.getItem("pageSessionID") !== SessionAttributes.SESSION_ID) {
		localStorage.setItem('pinchImageSessionCount', 0);
		localStorage.setItem('pageSessionID', SessionAttributes.SESSION_ID);
	}
}

function getProductImageURL(viewType) {
	var pid = $("span[data-productid='productID']").data("pid");
	return util.appendParamsToUrl(Urls.getProductImages, {
		"pid": pid,
		"sz": viewType
	});
}

function lazyLoadThumbnailsHandler(activeThumbnail,intialThumbnail) {
	var viewType = "thumbnail";
	var thumbnailProductImageURL = getProductImageURL(viewType);

	$.get(thumbnailProductImageURL).done(function (res) {
		$("#pdp-thumbnails-image").html(res);			
		customModal.modal();

		var thumbnailImageCount = $("#thumbnails li").length;
		if (thumbnailImageCount <= 1) {
			if (checkLayout == "desktop") {
				 $(".pdp-product-thumbnail-slider").addClass("pdp-product-thumbnail-slider-single");
                 return false;
			}
		} else {
			initThumbnailCarousel(activeThumbnail,intialThumbnail);
		}
	});
}

function initThumbnailCarousel(activeThumbnail,intialThumbnail) {
	var activeIndex = activeThumbnail,
		totalIndex = $('.pdp-product-thumbnail-slider > div').length;

	if(activeIndex >= totalIndex) {
		activeIndex = 0;
	}
	$('#thumbnails ul').not('.slick-initialized').slick({
		dots: false,
        infinite: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: activeIndex,
        accessibility: false,
        draggable: false,
		responsive: [			
			{
				breakpoint: 768,
				settings: {
					arrows: true,
				}
			}
		]
	});

	var settings = {
		dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        accessibility: false,
		variableWidth: false,
        nextArrow: '<button class="icon slick-next slick-arrow"><i class="icon-angle-right"></i></button>',
        prevArrow: '<button class="icon slick-prev slick-arrow"><i class="icon-angle-left"></i></button>',
	}

	if (totalIndex > 6) {
        if (intialThumbnail !== undefined) {
            settings.initialSlide = intialThumbnail;
        }
    } else {
        settings.slidesToShow = totalIndex;
    }

	$(".pdp-product-thumbnail-slider").not('.slick-initialized').slick(settings);

    stopAutoScrollProductThumbsSlider();

    $(".pdp-product-thumbnail-slider .slick-slide[data-slick-index|= 0]").addClass("clicked-slide");

    // Active last selected thumbnail.
    if (activeIndex !== undefined || activeIndex < totalIndex) {
        $("ul.product-images").slick("refresh");
        $(".pdp-product-thumbnail-slider").slick("refresh");
        $(".pdp-product-thumbnail-slider .slick-slide[data-slick-index|= " + activeIndex + "]").addClass("clicked-slide");
    }

    if (activeIndex == totalIndex - 1) {
	    setTimeout(function () {
	        $(".pdp-product-thumbnail-slider .slick-slide[data-slick-index|= " + activeIndex + "]").trigger("click");
	    }, 500);
    }
}

function thumbnailSlideHandler() {
	var currentSlide = $(this).attr("data-slick-index");
	$("ul.product-images").slick("slickGoTo", currentSlide);
	$(".pdp-product-thumbnail-slider .slick-slide").removeClass("clicked-slide");
	$(".pdp-product-thumbnail-slider .slick-slide[data-slick-index|= " + currentSlide + "]").addClass("clicked-slide");
}
$(document).on("click", ".pdp-product-thumbnail-slider .slick-active", thumbnailSlideHandler);
$(document).on("mouseenter", ".pdp-product-thumbnail-slider .slick-active", thumbnailSlideHandler);

function stopAutoScrollProductThumbsSlider() {
    if (window.innerWidth > 1023 && $(".pdp-product-thumbnail-slider .slick-slide").length <= 4) {
        $(".pdp-product-thumbnail-slider .slick-track").addClass("no-transform");
    }
}

/* Refresh PDP Main Image Slider */
function refreshPDPImageSlider(activeThumbnail, intialThumbnail) {
	$(document).on("click", ".close-try-it-on, .try-it-on.exitEnabled", function () {
		lazyLoadThumbnailsHandler(activeThumbnail, intialThumbnail);
	});
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
export default function (activeThumbnail, ajaxFlag, intialThumbnail) {

	lazyLoadThumbnailsHandler(activeThumbnail);
	resetVideoPlayer();
	lazyLoadThumbnailsHandler(activeThumbnail, intialThumbnail);

	if (SitePreferences.GIARAN_ENABLED) {
        refreshPDPImageSlider(activeThumbnail, intialThumbnail);
    }
	
	if(isTouchDevice) {
		var timer,
			pinchImageShowInterval = SitePreferences.PINCH_ZOOM_IMAGE_TIMEOUT * 1000,
			pinchZoomUtils = function(pinchImageDisplayCount) {
				if($('.pinch-img').is(":visible")) {
					$(document).on('touchstart click','.zoom-img, .pinch-img', function(){
						$('.pinch-img').hide();
					});
				}
				if(pinchImageShowInterval > 0 && pinchImageDisplayCount < 2) {
					localStorage.setItem('pinchImageSessionCount', pinchImageDisplayCount + 1);
				}
				window.clearTimeout(timer);
				timer = window.setTimeout(function(){
					$('.pinch-img').hide();
				}, pinchImageShowInterval);
			}
	}
	
	//Extract image type ex: jpg
	function checkImageType(url) {
		if (url.match(/\?./)) {
			return(url.substr((url.lastIndexOf('.') + 1)).split('?')[0]);
		} else {
			return(url.substr((url.lastIndexOf('.') + 1)));
		}
	}
	
	// bind zoom event handler - Desktop
	$('#thumbnails').on('click', '.productthumbnail', function (evt) {
		evt.preventDefault();
		!$(this).find('.video-thumbnail-wrapper').length > 0 && zoomProductImage(evt);
	});

	// Flag to track if video has been played
    let videoPlayed = false;

	// bind zoom event handler - Mobile
	$(document).on('click', '.product-images .slick-slide.slick-current.slick-active > div', function (evt) {
		evt.preventDefault();
		evt.stopPropagation();
		

		if (!$(this).find('.vid-thumbnail-play-btn').length) {
			zoomProductImage(evt);
			$('.zoomProductImage').css('display', 'block');
			setTimeout(() => {
				$('.pinch-img').hide();
			}, 2000);
		} else {
			$('#zoomProductImage').hide();
			if(!videoPlayed) {
				var video = $('.video-thumbnail-wrapper .product-vid');
				var videoID = $(this).parent().find('.product-vid').attr('id').split('_');
				$('.video-thumbnail-wrapper .vid-thumbnail-play-btn').addClass('in-active');
				$('.video-thumbnail-wrapper img.poster').addClass('in-active');
				$('.video-thumbnail-wrapper video').addClass('active');
				video[videoID[1]].play();
				videoPlayed = true; // Update the flag for video has been played
			}
		}
	});

	function zoomProductImage(evt) {
		var viewType = "zoom",
			zoomImageUrl = null,
			imageTypeFlag = false,
			imageExtention = '';

		if ($('.productthumbnail').length > 1) {
			if (window.innerWidth <= 768) {
				zoomImageUrl = evt.target.querySelector('li').dataset.zoomimg;
			} else {
				zoomImageUrl = $('#thumbnails .slick-current .productthumbnail').data('zoomimg');
			}
		} else {
			// for only one thumbnail, select that one image
			zoomImageUrl = $($('.productthumbnail')[0]).data('zoomimg');
		}

		$('.zoomProductImage .modal-body').html('<img class="zoom-img" src="' + zoomImageUrl + '">');
		$('.zoom-img').trigger('click');
		imageExtention = zoomImageUrl && checkImageType(zoomImageUrl).toLowerCase();
		if (imageExtention === 'jpg' || imageExtention === 'jpeg' || imageExtention === 'png') {
			imageTypeFlag = true;
		}

		if (isTouchDevice) {
			var pinchImageDisplayCount = parseInt(localStorage.getItem('pinchImageSessionCount')),
				pinchImage = (pinchImageShowInterval > 0 && pinchImageDisplayCount < 2 && imageTypeFlag) ? '<img class="pinch-img" src="' + Urls.pinchZoomImage + '">' : '';
			imagesLoaded('.pinch-zoom .zoom-img').on('done', function () {
				$('.zoomProductImage .modal-body').append(pinchImage);
			});
		}

		var widthModal_zoom = window.innerWidth;
		if (widthModal_zoom <= 1024 && isTouchDevice) {
			zoomTouch(pinchImageDisplayCount, imageTypeFlag);
		} else {
			$('.zoom-img').on('load', function () {
				var outerContent = $('#zoomProductImage .modal-body');
				var innerContent = $('#zoomProductImage .modal-body>img');
				outerContent.scrollLeft((innerContent.width() - outerContent.width()) / 2);
				outerContent.scrollTop((innerContent.height() - outerContent.height()) / 2);
				/* Reset dragscroll after ajax call */
				if (ajaxFlag !== undefined && ajaxFlag === true) {
					dragscroll.reset();
				}
			});
		}
	}
	
	function zoomTouch(pinchImageDisplayCount, imageTypeFlag) {
		var pdp_modal = $('#zoomProductImage').css('display') == 'none'
		if (screen.width > window.innerWidth) {
			screen.width = '100%';
		}
		if (imageTypeFlag) {
			var myel = document.querySelector('div.pinch-zoom');
			if (myel !== undefined) {
				new zoom.default(myel, {});
			}
			if(pinchImageShowInterval > 0 && pinchImageDisplayCount < 2 ) {
				imagesLoaded('.pinch-zoom .zoom-img, .pinch-zoom .pinch-img').on('done', function () {
					pinchZoomUtils(pinchImageDisplayCount);
				});
			}
		}
	}

	$(document).on('click', '.zoom-img', function (e) {
		if (window.innerWidth >= 1024 && !isTouchDevice) {
			dragscroll.reset();
		}
	}).on('click', '#zoomProductImage .modal-close, #zoomProductImage .modal-close-outer', function () {
		if (window.innerWidth <= 1024 && isTouchDevice) {
			$('.pinch-zoom').removeAttr('style');
			var innerHtml = $('.pinch-zoom-container').contents();
			$('.pinch-zoom-container').replaceWith(innerHtml);
		}
	});

	// handle product thumbnail click event
	$('#thumbnails').on('click', '.productthumbnail', function () {
		var $that = $(this);
		if (!$that.hasClass("selected")) {
			$(document).trigger("clickproductthumbnail"); 
		}

		$('#thumbnails').find('.productthumbnail.selected').removeClass('selected');
		$that.addClass('selected');
	});
	
	 // handle product thumbnail mouseenter event
    var active = false;
    $("body").on('click', '.productthumbnail.product-image-thumbnail, .productthumbnail.video-thumbnail-image', function (e) {
        if (!active) {
            var $that = $(this);
            if($that.hasClass("selected")){
                $that.trigger("click");
            }
            $("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
            $that.addClass('selected');
    	}
    });
    
    video.init(function () {
        $(document).on('afterChange', '.slick-slider.product-images', function(event, slick, currentSlide) {
        	var currentSlide = $(this).find(".slick-slide").eq(currentSlide);
        	resetVideoPlayer();
            setVideoPlayer(currentSlide.find('.product-video'));
			setVideoHeight();	
        });
    });

	if ($('.video-thumbnail-wrapper').length > 0) {
		//  Added unique ID to each video elements
		$('.productthumbnail .video-thumbnail-wrapper').parent().addClass('video-thumbnail');
		$('.video-thumbnail-wrapper .product-vid').each(function (index, value) {
			$(this).attr('id', 'thumnailvideo_' + index);
		});

		setTimeout(() => {
			// Custom Video pause on change of thumbnail, Show poster & Play Icon
			var slickSlide = $('#pdp-thumbnails-image .slick-slide');
			var videos = $('.video-thumbnail-wrapper video');

			slickSlide.on('mouseenter', function () {
				customVideoReset();
			});

			$('.product-image-container .product-images').on('afterChange', function () {
				customVideoReset();
			});

			$('.product-image-container .product-thumbnails .product-images .slick-arrow.slick-next, .product-image-container .product-thumbnails .product-images .slick-arrow.slick-prev').on('click', function () {
				customVideoReset();
			});

			function customVideoReset() {
				videoPlayed = false; // Update the flag for video has been played
				$('.video-thumbnail-wrapper .vid-thumbnail-play-btn').removeClass('in-active');
				$('.video-thumbnail-wrapper img.poster').removeClass('in-active');
				$('.video-thumbnail-wrapper video').removeClass('active');
				videos.each(function (index, video) {
						video.load();
						video.pause();
				});
			}
		}, 2000);
	}

	// Store the window width
    var winWidth = $(window).width();
	$(window).on('resize orientationchange', function () {
		// to prevent calling of resize event while scrolling in IOS devices
        if ($(window).width() != winWidth) {
            // Update the window width for next time
            winWidth = $(window).width();           
			
			// Do stuff here
            stopAutoScrollProductThumbsSlider();
			lazyLoadThumbnailsHandler(activeThumbnail, intialThumbnail);
        }
	});
};

function setVideoPlayer($slide) {
    if ($slide && $slide.length) {
    	var $element = $($slide[0]);
    	var videoID = $element.data('videoid');
    	if(!videoID)    {return;}

        $element.find(".video-wrapper").html('<div id="videoplayer_pdp"></div>');
        videoplayer = video.playerThumbnail($("#videoplayer_pdp"), videoID);
    }
}

function resetVideoPlayer() {
    if(videoplayer) {
        videoplayer.destroy();
        videoplayer = null;
    }
}

function setVideoHeight() {
	var slider = $("#thumbnails .product-images.slick-initialized"),
		videoPlayer = $("#videoplayer_pdp");	
	if(slider.length && videoPlayer.length) {
		videoPlayer.height(slider.find(".slick-slide").width());
		videoPlayer.closest(".slick-slide").css("line-height","0");
	}
}

export const lazyLoadThumbnails = lazyLoadThumbnailsHandler;